module.exports = __webpack_public_path__ + "files/observation.d2e9b060451d4c75a8a81665b982ee75.pdf";